import { logEvent } from "@src/utils/logClient";
import { getTrackedUtmParams } from "@src/utils/sparks/getTrackedUtmParams";

type SparksEventOptions = {
  eventName: string;
  eventValue?: string | number;
  metadata?: Record<string, unknown>;
};

export const logSparksEvent = ({ eventName, eventValue, metadata = {} }: SparksEventOptions) => {
  const utmParams = getTrackedUtmParams();

  return logEvent({
    eventName,
    eventValue,
    metadata: {
      ...metadata,
      ...utmParams,
    },
  });
};
